/**
 * Route for `disallowed-traffic-channels-per-offer`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DisallowedTrafficChannelsPerOfferPage } from "../features/disallowed-traffic-channels-per-offer/DisallowedTrafficChannelsPerOfferPage";

export const disallowedTrafficChannelsPerOfferRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/disallowed-traffic-channels-per-offer",
	component: DisallowedTrafficChannelsPerOfferPage,
});

export default disallowedTrafficChannelsPerOfferRoute;
